module.exports = __webpack_public_path__ + "img/AB5_5010.d792d160.jpg";